import type { AgenticLogicRuleSettings } from "@intelligems/ig-types/dtos/agentic-logic/rules";
import { useUpdateAgenticLogicRule } from "@src/api/agentic-logic/update-agentic-logic-rule";

/** Display settings belong to the saved draft. Publishing is a separate action. */
export const useSaveRuleSettings = (ruleId: string) => {
  const updateRule = useUpdateAgenticLogicRule();
  return {
    isSaving: updateRule.isPending,
    save: async (settings: AgenticLogicRuleSettings): Promise<void> => {
      await updateRule.mutateAsync({
        body: { settings },
        pathParams: { ruleId },
        queryParams: undefined,
      });
    },
  };
};
